// extracted by mini-css-extract-plugin
module.exports = {"note":"_1ax6ct","text":"_1alJKh","button":"_3d4-8s","prepaidCardWithDiscountModal":"_2DrZZd"};